<template>
  <div class="shell">
    <aside>
      <div class="brand">✦ <b>医路学</b></div>
      <nav>
        <router-link v-for="m in modules" :key="m.path" :to="m.path">
          <span class="nav-emoji">{{ m.emoji }}</span> <span>{{ m.name }}</span>
        </router-link>
        <div class="nav-sep"></div>
        <router-link to="/history"><span class="nav-emoji">🕘</span> <span>历史记录</span></router-link>
      </nav>
      <!-- 左下角：真实用户状态 -->
      <div class="side-foot" v-if="user">
        <template v-if="!user.expired">
          <span class="vip">● 会员生效中</span><br>
          <small>至 {{ fmtDate(user.expireAt) }}</small>
        </template>
        <template v-else>
          <span class="expired">● {{ user.expireAt ? '已到期' : '未开通' }}</span><br>
          <small><router-link to="/profile" style="color:var(--accent)">兑换续费 →</router-link></small>
        </template>
      </div>
      <div class="side-foot" v-else>
        <small>未登录</small>
      </div>
    </aside>
    <main>
      <header>
        <strong>医学生 AI 高效学习工具</strong>
        <!-- 右上角：主题切换 + 真实用户入口 -->
        <div class="user-area">
          <theme-switch />
          <template v-if="user">
            <router-link to="/profile" class="user-chip">
              <span class="avatar">{{ (user.name || '学')[0] }}</span>
              <span>{{ user.name }}</span>
              <span class="tag" :class="user.expired ? 'off' : 'vip'">{{ user.expired ? '未开通' : 'VIP' }}</span>
            </router-link>
          </template>
          <router-link v-else to="/auth" class="btn" style="text-decoration:none;padding:8px 18px">登录 / 注册</router-link>
        </div>
      </header>
      <router-view />
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ThemeSwitch from './components/ThemeSwitch.vue';

export default {
  name: 'App',
  components: { ThemeSwitch },
  computed: {
    ...mapState('auth', ['user']),
  },
  data: () => ({
    modules: [
      { path: '/mnemonic', emoji: '🧠', name: '口诀记忆' },
      { path: '/patient', emoji: '🩺', name: '临床问诊' },
      { path: '/dx-chain', emoji: '🔬', name: '鉴别诊断' },
      { path: '/record', emoji: '📋', name: '病历生成' },
      { path: '/training', emoji: '📚', name: '问诊训练' },
      { path: '/mistakes', emoji: '❌', name: '错题本' },
      { path: '/disease', emoji: '💊', name: '病种解读' },
    ],
  }),
  methods: {
    fmtDate(d) { return d ? new Date(d).toLocaleDateString('zh-CN') : '-'; },
  },
};
</script>

<style scoped>
.nav-sep { height: 1px; background: var(--border-1); margin: 10px 6px; }
.side-foot .vip { color: var(--success); font-size: 12px; }
.side-foot .expired { color: var(--warn); font-size: 12px; }
.user-area { margin-left: auto; display: flex; align-items: center; gap: 12px; }
.user-chip { display: flex; align-items: center; gap: 8px; color: var(--text-1); text-decoration: none; background: var(--bg-2); border: 1px solid var(--border-1); border-radius: 999px; padding: 5px 14px 5px 6px; transition: border-color 0.2s; }
.user-chip:hover { border-color: var(--border-hi); }
.avatar { width: 26px; height: 26px; display: grid; place-items: center; background: var(--grad-primary); border-radius: 50%; font-size: 12px; }
.tag.vip { background: var(--success-a15); color: var(--success); font-size: 10px; padding: 1px 8px; border-radius: 999px; }
.tag.off { background: var(--bg-1); color: var(--text-3); font-size: 10px; padding: 1px 8px; border-radius: 999px; }
</style>
